import { CommonModule } from "@angular/common";
import {
  Component,
  inject,
  Input,
  OnInit,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";


export interface RequirementNameInfo {
  name: string;
  id: string;
  path: string;
}

export interface RequirementItem {
  requirementId: string;
  requirementTitle: string;
}

export interface ErrorConditionItem {
  condition: string;
  expectedResult: string;
}

export interface DependencyItem {
  section: string;
  dependency: string;
}

export interface RequirementDetailsData {
  nameInfo: RequirementNameInfo;
  requirements: RequirementItem[];
  validation: string[];
  uiBehavior: string[];
  errorConditions: ErrorConditionItem[];
  dependencies: DependencyItem[];
  headingPath: string[];
}

interface NavItem {
  label: string;
  sectionId: string;
}

@Component({
  selector: "app-requirement-details-modal",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./requirement-details-modal.component.html",
  styleUrl: "./requirement-details-modal.component.scss",
})
export class RequirementDetailsModalComponent implements OnInit {
  /** Full requirement data to display. */
  @Input() data: RequirementDetailsData | null = null;

  readonly activeModal = inject(NgbActiveModal);

  /** Tracks which sidebar item is active (highlighted). */
  activeSection = "section-name";

  /** Whether the close button is in pressed state (icon swap). */
  isCloseActive = false;

  readonly navItems: NavItem[] = [
    { label: "Name, ID & Path", sectionId: "section-name" },
    { label: "Requirements",    sectionId: "section-requirements" },
    { label: "Validation",      sectionId: "section-validation" },
    { label: "UI Behavior",     sectionId: "section-ui-behavior" },
    { label: "Error Conditions",sectionId: "section-error-conditions" },
    { label: "Dependencies",    sectionId: "section-dependencies" },
    { label: "Heading Path",    sectionId: "section-heading-path" },
  ];

  ngOnInit(): void {
    // Nothing to initialise beyond what the template drives.
  }

  /** Scrolls the content area to the given section and marks it active. */
  scrollTo(sectionId: string): void {
    this.activeSection = sectionId;
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  close(): void {
    this.activeModal.close();
  }
}
